import { push }                                                                          from "connected-react-router";
import { clearSubSection }                                                               from "dmpconnectjsapp-base/actions";
import { formatUpdateUserDmpAccessAuthorizationParams }                                  from "dmpconnectjsapp-base/actions/config/commandParamsFormatters";
import commands                                                                          from "dmpconnectjsapp-base/actions/config/commands";
import { apiSections }                                                                   from "dmpconnectjsapp-base/constants";
import { isAirActive }                                                                   from "dmpconnectjsapp-base/helpers/accessors";
import { isLoading, isReady }                                                            from "dmpconnectjsapp-base/helpers/common";
import { authenticationTypes, getAccessRightsProps, isTransactionAllowed, transactions } from "dmpconnectjsapp-base/rules/accessRights";
import PropTypes                                                                         from "prop-types";
import React, { useMemo } from "react";

import { Button, Form, Modal }                                                     from "react-bootstrap";
import { connect }                                                                 from "react-redux";
import { getAction, handleActionsWithSecretConnection, setDmpAccessMode }          from "../../dmpconnect/actions";
import { accessModes, userAuthorizationAction, userAuthorizationStatuses }         from "../../dmpconnect/constants";
import { getFullName }                                                             from "../../dmpconnect/helpers/accessibleDMPList";
import { getDirectAuthenticationStatus, getPatientInfosFromState, isPatientMinor } from "../../dmpconnect/helpers/directAuthenticationDMPStatus";
import env                                                                         from "../../envVariables";
import ButtonWithLoader                                                            from "../Common/Form/ButtonWithLoader";
import CustomCheckbox                                                              from "../Common/Form/Input/CustomCheckbox";
import SwitchCheckbox                                                              from "../Common/Form/Input/SwitchCheckbox";
import Alert                                                                       from "../Common/Message/Alert";
import TitleTooltip                                                                from "../Common/TitleTooltip";

export const displayModes = {
  FULL     : "FULL",
  EMERGENCY: "EMERGENCY",
  NORMAL   : "NORMAL"
};

const initialState = displayMode => ({
  show               : false,
  reason             : "",
  authorizationType  :
    displayMode === displayModes.EMERGENCY
      ? "emergency_access"
      : null,
  emergencyAccessMode: accessModes.Centre15
});

const DmpAuthorization = ({
  ins,
  dispatch,
  standalone,
  displayMode,
  directAuthenticationStatus,
  accessRights,
  loading,
  secretConnection,
  onClose,
  isMobile,
  regulationMode,
  isMinor,
  patientInfos
}) => {
  const [show, setShow]                               = React.useState(standalone);
  const [reason, setReason]                           = React.useState("");
  const [authorizationType, setAuthorizationType]     = React.useState(null);
  const [emergencyAccessMode, setEmergencyAccessMode] = React.useState(
    accessModes.Centre15
  );

  const isAuthExpired = useMemo(() => {
    const {
      ExistingTestAnswer: {
        psAuthorization,
        esAuthorization,
        i_userAuthorization,
      } = {},
    } = directAuthenticationStatus || {};

    return (
      i_userAuthorization === userAuthorizationStatuses.AuthorizationExpired ||
    psAuthorization ===
        userAuthorizationStatuses.AuthorizationExpired ||
      esAuthorization === userAuthorizationStatuses.AuthorizationExpired
    );
  }, [directAuthenticationStatus]);
  
  const handleClose = React.useCallback(() => {
    if (standalone) {
      if (onClose) {
        onClose();
      } else {
        dispatch(push(`/home/`));
      }
    } else {
      setShow(false);
    }
  }, []);
  
  const handleShow = React.useCallback(() => {
    // dispatch(clearSection(apiSections.DMP_ACCESS_MODE_SECTION));
    dispatch(clearSubSection(apiSections.USER_DMP_ACCESS_AUTHORIZATION_SECTION, ins));
    const initState = initialState(displayMode);
    setShow(true);
    setReason(initState.reason);
    setAuthorizationType(initState.authorizationType);
    setEmergencyAccessMode(initState.emergencyAccessMode);
  }, []);
  
  const updateAuthorization = (secret) => {
    const {
            authenticationType, psId, esId, airOnly,
            [transactions.AUTHORIZED_DMPS]: auth
          } = accessRights;
    const {
            ExistingTestAnswer: {
              psAuthorization,
              esAuthorization
            } = {}
          } = (directAuthenticationStatus || {});
    
    if (
      authorizationType === "normal_access"
    ) {
      const actions = [];
      if (
        !psAuthorization
        || (psAuthorization && psAuthorization !== userAuthorizationStatuses.AuthorizationExist)
      ) {
        actions.push(getAction(
          commands.updateUserDmpAccessAuthorization,
          apiSections.USER_DMP_ACCESS_AUTHORIZATION_SECTION,
          formatUpdateUserDmpAccessAuthorizationParams(
            ins,
            userAuthorizationAction.AddAuthorization,
            0
          ),
          {
            subSection   : `${ins}/${psId}`,
            contextParams: { ins, performer: psId, authorizedDmpsTransaction: auth }
          }
        ));
        
      }
      
      if (
        !airOnly
        && authenticationType === authenticationTypes.AIR
        && esAuthorization !== userAuthorizationStatuses.AuthorizationExist
      ) {
        actions.push(getAction(
          commands.updateUserDmpAccessAuthorization,
          apiSections.USER_DMP_ACCESS_AUTHORIZATION_SECTION,
          formatUpdateUserDmpAccessAuthorizationParams(
            ins,
            userAuthorizationAction.AddAuthorization,
            0
          ),
          {
            subSection   : `${ins}/${esId}`,
            contextParams: { ins, performer: esId },
            forceEs      : true
          }
        ));
      }
      
      if (!!secret) {
        dispatch(handleActionsWithSecretConnection(actions, ins, secret));
      } else {
        actions.forEach(action => dispatch(action));
      }
    } else {
      dispatch(setDmpAccessMode(emergencyAccessMode, reason, ins));
    }
  };
  
  if (!regulationMode && !isTransactionAllowed(accessRights, transactions.AUTHORIZATION_ADD)) {
    return <></>;
  }
  
  const { allowedAccessModes } = accessRights;
  if (
    displayMode === displayModes.EMERGENCY
    && (
      Number(env.REACT_APP_DISABLE_EMERGENCY_ACCESS) === 1
      || !allowedAccessModes.some(access => [accessModes.BrisDeGlace, accessModes.Centre15].includes(access))
    )
  ) {
    return <></>;
  }
  
  const isValid = (
    !!authorizationType
    && (
      Number(emergencyAccessMode) !== accessModes.BrisDeGlace
      || (reason !== "" && Number(emergencyAccessMode) === accessModes.BrisDeGlace)
    )
  );
  
  const centre15Active = regulationMode
                         || (
                           authorizationType === "emergency_access"
                           && allowedAccessModes.includes(accessModes.Centre15)
                           && Number(emergencyAccessMode) === accessModes.Centre15
                         );
  
  const bdgActive = authorizationType === "emergency_access"
                    && allowedAccessModes.includes(accessModes.BrisDeGlace)
                    && Number(emergencyAccessMode) === accessModes.BrisDeGlace;
  
  return (
    <>
      {!standalone && (
        <>
          {(displayMode === displayModes.FULL || displayMode === displayModes.NORMAL) && (
            <TitleTooltip
              id="add-access"
              text="Ajouter une autorisation d'accès"
            >
              <Button
                id="addAuthButton"
                variant="outline-no-access"
                size="sm"
                onClick={() => handleShow()}
              >
                <i className="ic-dmp-no-autorisation" />
                DMP
              </Button>
            </TitleTooltip>
          )}
          {displayMode === displayModes.EMERGENCY && (
            <TitleTooltip
              id="emergency-access"
              text="Accéder en mode urgence"
            >
              <Button
                size="sm"
                id="emergencyAccessButton"
                variant="outline-warning"
                onClick={() => handleShow()}
              >
                <i className="ic-dmp-no-autorisation" />
                Urgence
              </Button>
            </TitleTooltip>
          )}
        </>
      )}
      <Modal
        id="authModal"
        size="lg"
        centered
        backdrop="static"
        keyboard={false}
        show={show}
        onHide={() => handleClose()}
      >
        <Modal.Header closeButton={!standalone}>
          <Modal.Title as="h5">Accéder au DMP de {getFullName(patientInfos.name, patientInfos.givenName, patientInfos.birthName)}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {(displayMode === displayModes.FULL || displayMode === displayModes.NORMAL) && (
            <>
              {isAuthExpired && (
                <Alert type="warning">Votre autorisation d'accès à ce DMP a expirée.</Alert>
              )}
              <div className="typography-default-text-title">
                Ajouter une autorisation
              </div>
              <div className="toggle-checkbox-container mt-2">
                <div className={`toggle-checkbox ${!isMobile ? "border" : ""} ${authorizationType === "normal_access" ? "active" : ""}`}>
                  {isMobile ? (
                    <SwitchCheckbox
                      id="dmp-add-access"
                      onChange={(event) => {
                        const { target: { checked } } = event;
                        if (checked) {
                          setAuthorizationType("normal_access");
                          setEmergencyAccessMode(null);
                        }
                      }}
                      name="authorizationType"
                      checked={authorizationType === "normal_access"}
                      showLabel
                      onLabel="Le patient (ou son représentant légal), préalablement informé, consent au fait que j’accède à son DMP."
                      offLabel="Le patient (ou son représentant légal), préalablement informé, consent au fait que j’accède à son DMP."
                    />
                  ) : (
                    <CustomCheckbox
                      type="radio"
                      id="dmp-add-access"
                      checked={authorizationType === "normal_access"}
                      label="Le patient (ou son représentant légal), préalablement informé, consent au fait que j’accède à son DMP."
                      value="normal_access"
                      name="authorizationType"
                      onChange={(event) => {
                        const { target: { checked } } = event;
                        if (checked) {
                          setAuthorizationType("normal_access");
                          setEmergencyAccessMode(null);
                        }
                      }}
                    />
                  )}
                </div>
              </div>
              <Alert type="info" className="mt-3">
                Avec le consentement patient, le logiciel pourra effectuer des requêtes de recherches de
                documents au nom de l'utilisateur authentifié sur le DMP et permettra de les consulter sur
                action manuelle.
                <br />
                Ces interactions sont tracées avec l'identifiant national du professionnel
                authentifié et <strong>le patient sera notifié immédiatement de ces interactions.
                <br />
                Toutes
                recherches et/ou consultations de ma part d'un document pour lequel le patient ne
                m'a pas autorisé et/ou je ne fais pas partie de l'équipe de soins m'expose à des
                poursuites.</strong>
              </Alert>
              {authorizationType === "normal_access" && isMinor === true && secretConnection !== false && (
                <div className="ml-4 mt-3">
                  Le patient est mineur : vous pouvez accéder de façon confidentielle à son DMP.

                  <Alert type="info" className="mt-3">
                    La connexion secrète permet de bloquer l&apos;envoi d&apos;une notification de premier accès et la consulation de la
                    trace d&apos;accès au représentants légaux afin de préserver le secret du mineur titulaire du DMP.
                    <br />
                    <br />
                    Cette modalité de connexion doit être exclusivement réservée au cas de préservation de secret des mineurs encadré dans
                    la réglementation en vigueur.
                    <br />
                    <br />
                    Le médecin traitant du mineur peut consulter à tout moment l&apos;historique d&apos;accès, même en cas de connexion
                    secrète.
                  </Alert>
                </div>
              )}
            </>
          )}
          {[accessModes.BrisDeGlace, accessModes.Centre15].some(access => allowedAccessModes.includes(access)) && (
            <>
              {!regulationMode && (
                <div className="typography-default-text-title mt-3 mb-2">En mode bris de glace</div>
              )}
              <div className="toggle-checkbox-container">
                {regulationMode && (
                  <div className={`toggle-checkbox  ${!isMobile ? "border" : ""} ${centre15Active ? "active" : ""}`}>
                    {isMobile ? (
                      <SwitchCheckbox
                        id="dmp-access-regu"
                        onChange={(event) => {
                          const { target: { checked } } = event;
                          if (checked) {
                            setAuthorizationType("emergency_access");
                            setEmergencyAccessMode(accessModes.Centre15);
                          }
                        }}
                        name="emergencyAccessMode"
                        checked={centre15Active}
                        showLabel
                        onLabel="Régulation Samu / Centre 15"
                        offLabel="Régulation Samu / Centre 15"
                        disabled={!allowedAccessModes.includes(accessModes.Centre15)}
                      />
                    ) : (
                      <CustomCheckbox
                        type="radio"
                        id="dmp-access-regu"
                        label="Régulation Samu / Centre 15"
                        value={accessModes.Centre15}
                        checked={centre15Active}
                        name="emergencyAccessMode"
                        onChange={(event) => {
                          const { target: { checked } } = event;
                          if (checked) {
                            setAuthorizationType("emergency_access");
                            setEmergencyAccessMode(accessModes.Centre15);
                          }
                        }}
                        disabled={!allowedAccessModes.includes(accessModes.Centre15)}
                      />
                    )}
                  </div>
                )}
                {!regulationMode && (
                  <div className={`toggle-checkbox  ${!isMobile ? "border" : ""} ${bdgActive ? "active" : ""}`}>
                    {isMobile ? (
                      <SwitchCheckbox
                        id="dmp-access-bdg"
                        onChange={(event) => {
                          const { target: { checked } } = event;
                          if (checked) {
                            setAuthorizationType("emergency_access");
                            setEmergencyAccessMode(accessModes.BrisDeGlace);
                          }
                        }}
                        name="emergencyAccessMode"
                        checked={bdgActive}
                        showLabel
                        onLabel="Risque immédiat pour la santé du patient"
                        offLabel="Risque immédiat pour la santé du patient"
                        disabled={!allowedAccessModes.includes(accessModes.BrisDeGlace)}
                      />
                    ) : (
                      <CustomCheckbox
                        type="radio"
                        id="dmp-access-bdg"
                        label="Risque immédiat pour la santé du patient"
                        value={accessModes.BrisDeGlace}
                        checked={bdgActive}
                        name="emergencyAccessMode"
                        onChange={(event) => {
                          const { target: { checked } } = event;
                          if (checked) {
                            setAuthorizationType("emergency_access");
                            setEmergencyAccessMode(accessModes.BrisDeGlace);
                          }
                        }}
                        disabled={!allowedAccessModes.includes(accessModes.BrisDeGlace)}
                      />
                    )}
                  </div>
                )}
              </div>

              {
                !regulationMode
                && authorizationType === "emergency_access"
                && allowedAccessModes.includes(accessModes.BrisDeGlace)
                && Number(emergencyAccessMode) === accessModes.BrisDeGlace
                && (
                  <Form.Group controlId="reason" className="mt-3">
                    <Form.Label>Motif de l&#39;accès en urgence au DMP</Form.Label>
                    <Form.Control
                      name="reason"
                      value={reason}
                      as="textarea"
                      rows="3"
                      required
                      onChange={event => setReason(event.target.value)}
                    />
                  </Form.Group>
                )
              }
            </>
          )}

        </Modal.Body>
        <Modal.Footer className="justify-content-between">
          <Button
            size="sm"
            variant={isMobile ? "borderless-primary" : "outline-secondary"}
            onClick={() => handleClose()}
          >
            Annuler
          </Button>
          <div>
            {authorizationType === "normal_access" && isMinor === true && secretConnection !== false && (
              <ButtonWithLoader
                size="sm"
                variant="danger"
                className="mr-2"
                id="authModalSubmit"
                label="Connexion secrète"
                onClick={() => updateAuthorization(true)}
                loading={loading}
                disabled={!isValid}
              />
            )}
            {(!secretConnection || authorizationType !== "normal_access") && (
              <ButtonWithLoader
                size="sm"
                id="authModalSubmit"
                label={authorizationType === "normal_access" && isMinor === true ? "Connexion normale" : "Accéder au DMP"}
                onClick={() => updateAuthorization()}
                loading={loading}
                disabled={!isValid}
              />
            )}
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
  
};

function mapStateToProps (state, props) {
  const { ins }          = props;
  const { accessRights } = getAccessRightsProps(state);
  const { psId, esId }   = accessRights;
  
  const
    {
      dmpconnect: {
        [apiSections.DMP_ACCESS_MODE_SECTION]              : dmpAccessMode,
        [apiSections.USER_DMP_ACCESS_AUTHORIZATION_SECTION]: {
          [`${ins}/${psId}`]: psUserDmpAccessAuthorization,
          [`${ins}/${esId}`]: esUserDmpAccessAuthorization
        },
        secretConnection,
        [apiSections.CONFIDENTIALITY_LEVEL_SECTION]: {
          [props.ins]: confidentialityLevelSection
        },
        dmpconnectUser                             : {
          forceSecretConnexion: {
            [ins]: forceSecretConnexion
          } = {}
        } = {}
      }
    } = state;
  
  return {
    accessRights,
    psUserDmpAccessAuthorization,
    directAuthenticationStatus: getDirectAuthenticationStatus(state, ins),
    air                       : isAirActive(state),
    loading                   : isLoading(psUserDmpAccessAuthorization) || isLoading(esUserDmpAccessAuthorization) || isLoading(dmpAccessMode),
    secretConnection          : isReady(confidentialityLevelSection) ? secretConnection === 1 : undefined,
    isMinor                   : isPatientMinor(state, ins) || forceSecretConnexion,
    patientInfos              : getPatientInfosFromState(state, ins)
  };
}

DmpAuthorization.defaultProps = {
  standalone                : false,
  displayMode               : displayModes.FULL,
  directAuthenticationStatus: {},
  patientInfos: {},
  loading                   : false,
  forceSecretConnexion      : false,
  secretConnection          : undefined,
  debugMinorAge             : null,
  onClose                   : undefined,
  isMobile                  : false,
  regulationMode            : false
};

DmpAuthorization.propTypes = {
  ins                       : PropTypes.string.isRequired,
  dispatch                  : PropTypes.func.isRequired,
  standalone                : PropTypes.bool,
  displayMode               : PropTypes.string,
  directAuthenticationStatus: PropTypes.object,
  patientInfos: PropTypes.object,
  accessRights              : PropTypes.object.isRequired,
  loading                   : PropTypes.bool,
  minimumMinorAge           : PropTypes.number.isRequired,
  debugMinorAge             : PropTypes.number,
  forceSecretConnexion      : PropTypes.bool,
  secretConnection          : PropTypes.bool,
  onClose                   : PropTypes.func,
  isMobile                  : PropTypes.bool,
  regulationMode            : PropTypes.bool
};

export default connect(mapStateToProps)(DmpAuthorization);

